import { useDispatch } from 'react-redux';
import React, { useLayoutEffect, useEffect } from 'react';

import { togglePageRendered, togglePageRendering } from '../store/actions';

export const withPageEvent = (WrappedComponent) => (props) => {
    const { isPageInPopup } = props;
    const dispatch = useDispatch();
    const PAGE_RENDERED_TIMEOUT = 1000;

    useLayoutEffect(() => {
        if (isPageInPopup) {
            return;
        }

        dispatch(togglePageRendering(true));
    }, [dispatch, isPageInPopup]);

    useEffect(() => {
        if (isPageInPopup) {
            return;
        }

        setTimeout(() => {
            dispatch(togglePageRendering(false));
            dispatch(togglePageRendered(true));
        }, PAGE_RENDERED_TIMEOUT);

        return () => {
            dispatch(togglePageRendered(false));
        };
    }, [dispatch, isPageInPopup]);

    return (
        <WrappedComponent {...props} />
    );
};
